module.exports = __webpack_public_path__ + "img/auto_topup_registrations.a916784b.svg";